import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@mui/material';
import Spinner from '../../../ChimeMeeting/components/icons/Spinner';
const ScormPlaceholder = () => (_jsx(Box, { sx: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
    }, children: _jsx(Spinner, {}) }));
export default ScormPlaceholder;
//# sourceMappingURL=ScormPlaceholder.js.map